import { UrlParamKeys } from '../../app/UrlParamKeys';
import { FlowContentType } from '../models/ContentTypes';
import { FlowDetailInfo } from '../models/FlowInfo';
import { Module } from '../Module';
import { ContentUrlForItem } from '../services/ContentUrl';
import { PublishFlowAction } from '../services/PublishFlowAction';
import { Location } from './../../common/react/Location';

export class FlowPublishResultCtrl {

  public static $inject = [
    'flowDetailInfo',
    'FlowPublishResultService',
  ];

  constructor(
    flowDetailInfo: FlowDetailInfo,
    flowPublishResultService: FlowPublishResultService,
  ) {
    flowPublishResultService.handlePublishedFlow(flowDetailInfo);
  }
}

Module.instance().controller('FlowPublishResultCtrl', FlowPublishResultCtrl);

export class FlowPublishResultService {

  public static $inject = [
    '$location',
    '$rootScope',
    'PublishFlowAction',
    '$state',
  ];

  constructor(
    private $location: ng.ILocationService,
    private $rootScope: ng.IRootScopeService,
    private PublishFlowAction: PublishFlowAction,
    private $state: ng.ui.IStateService,
  ) {
  }

  public handlePublishedFlow(flowDetailInfo: FlowDetailInfo) {
    const search = this.$location.search();

    const publishedDatasourcesStr: string = search[UrlParamKeys.PublishedDataSources];
    const publishedDatasourceUrlNames: string[] = publishedDatasourcesStr ? publishedDatasourcesStr.split(',') : [];

    // With the new stylishFlow work, this entire block can be deleted because
    // react router will handle this redirect else where.

    // If we open the modal now and then initiate a state change, the modal will not open properly.
    // So, we'll wait for the state to finish changing and then open the modal
    const removeEvent = this.$rootScope.$on('$locationChangeSuccess',
      () => {
        removeEvent();
        this.PublishFlowAction.handlePublishedFlow(flowDetailInfo, publishedDatasourceUrlNames);
      }
    );

    this.$state.go('main.site.content.flow.overview');
  }
}

Module.instance().service('FlowPublishResultService', FlowPublishResultService);
